import z from 'zod';
import { WorkOrderItemEntitySchema } from './WorkOrderItemEntity';

export const WorkOrderItemWithOptionsSchema = WorkOrderItemEntitySchema.extend({
    options: z.record(z.string(), z.any()),
    labels: z.record(z.string(), z.any()),
});

export type WorkOrderItemWithOptions = z.infer<typeof WorkOrderItemWithOptionsSchema>;
